import styled from 'styled-components';
 
export const Container = styled.div`
   display: flex;
   justify-content: center;
   align-items: center;
   font-size: 1.5rem;
`
export const Radio = styled.input`
   display: none;
`
export const Rating = styled.div`
   cursor: pointer;
`
